import http from "../../utils/httpClient";

class auditService {
  getCategoryWiseExcelReport = async (query) => {
    return await http.get("/api/PurchaseOrder/GetCatwiseInvAuditReport", {
      params: query,
    });
  };
}

export default new auditService();
